import CompanyTool from '../tools/CompanyTool';

let messages = {}

// Functions tools
var createNestedObject = (base, names) => {
    for (var i = 0; i < names.length; i++)
        base = base[names[i]] = base[names[i]] || {};
}

var addValueObject = (obj, path, value) => {
    let i = 0
    for (i = 0; i < path.length - 1; i++)
        obj = obj[path[i]];
    obj[path[i]] = value;
}

function getPropByString(obj, propString) {
    if (!propString)
        return obj;
  
    var prop, props = propString.split('.');
  
    for (var i = 0, iLen = props.length - 1; i < iLen; i++) {
        prop = props[i];
  
        var candidate = obj[prop];
        if (candidate !== undefined) {
            obj = candidate;
        } else {
            break;
        }
    }
    return obj[props[i]];
  }

var arrayFilesToMessages = (arr) => {
    let jsonFile = null
    let deepPath = null
    arr.forEach(defaultLabel => {
        try {
            // Read file
            jsonFile = require('./../lang/default/' + defaultLabel + '.lang.json')
            // Transform path to array
            deepPath = defaultLabel.split('/')
            // Init object deep
            createNestedObject(messages, deepPath)
            // Add file value
            addValueObject(messages, deepPath, jsonFile)
        } catch (e) {
            console.error("Can't open " + defaultLabel + " lang file")
        }
    })
}

// Init object
let defaultConfFile = require('./../lang/default/conf').default
let companyDirectory = CompanyTool.confFile() ? CompanyTool.confFile().overwrite_folder : 'default'
let companyConfLangFile = null
arrayFilesToMessages(defaultConfFile)

try {
    companyConfLangFile = require(`../companies/${companyDirectory}/lang/conf.js`).default
} catch (e) {
    console.error("i18n: cannot open conf file");
}

if (companyConfLangFile) {
    let arrayPath = null
    let arrayPathWithKeyname = null
    let fileContent = null
    companyConfLangFile.forEach(file => {
        arrayPath = file.split('/')

        try {
            fileContent = require('./../companies/' + companyDirectory + '/lang/' + file + '.lang.json')
            for (let indexFileContent in fileContent) {
                arrayPathWithKeyname = [...arrayPath]
                arrayPathWithKeyname.push(indexFileContent)
        
                // If exists: overwrite
                if (getPropByString(messages, arrayPathWithKeyname.join('.'))) {
                    addValueObject(messages, arrayPathWithKeyname, fileContent[indexFileContent])
                } else {
                    // Else: create
                    createNestedObject(messages, arrayPathWithKeyname)
                    addValueObject(messages, arrayPathWithKeyname, fileContent[indexFileContent])
                }
            }
        } catch (e) {
            console.error("Can't open " + file + " lang file in " + companyDirectory + ' directory')
        }
    })
}

console.log(messages);
export default messages



// WEBPACK FOOTER //
// ./src/i18n/i18n.js